import { Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { Except } from "type-fest";
import { SecondaryButton } from "../Common/SecondaryButton";

interface BookingEngineWarningModalProps {
    bookingEngine: string;
    isOpen: boolean;
    onClose?: () => void;
    onContinue: () => void;
}

export const BookingEngineWarningModal = ({
    bookingEngine,
    isOpen,
    onClose,
    onContinue,
}: BookingEngineWarningModalProps) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <BookingEngineWarningModalContent bookingEngine={bookingEngine} onClose={onClose} onContinue={onContinue} />
    </Modal>
);

export const BookingEngineWarningModalContent = ({
    bookingEngine,
    onClose,
    onContinue,
}: Except<BookingEngineWarningModalProps, "isOpen">) => (
    <>
        <Modal.Header>Warning: {bookingEngine} Reservation</Modal.Header>
        <Modal.Body className="space-y-4">
            <div className="flex flex-col space-y-2">
                <span>
                    You are about to modify a reservation that came from <strong>{bookingEngine}</strong>. The{" "}
                    {bookingEngine} integration does not support two-way synchronization.
                    <strong>
                        If you confirm this change, this reservation will be no longer be in sync with the reservation
                        record of {bookingEngine}.
                    </strong>
                </span>
                <span>Are you sure you wish to proceed with this change?</span>
            </div>
        </Modal.Body>
        <Modal.Footer className="flex justify-end">
            <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
            <SubmitButton onClick={onContinue}>Continue</SubmitButton>
        </Modal.Footer>
    </>
);
